import { render, staticRenderFns } from "./ReferralManagement.vue?vue&type=template&id=42d73656&scoped=true"
import script from "./ReferralManagement.vue?vue&type=script&lang=ts"
export * from "./ReferralManagement.vue?vue&type=script&lang=ts"
import style0 from "./ReferralManagement.vue?vue&type=style&index=0&id=42d73656&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42d73656",
  null
  
)

export default component.exports